import {
  CART_LOGIN_REDIRECT_EXPERIMENT_NAME,
  DESKTOP_STICKY_BUY_EXPERIMENT_NAME,
  PDP_SAVE_BADGE_EXPERIMENT_NAME,
  HIDE_STICKY_TABS_EXPERIMENT_NAME,
  PROJECT_FOMO_EXPERIMENT_NAME,
  USE_NEXT_PDP_EXPERIMENT_NAME,
  USE_NEXT_QUESTION_REVIEW_EXPERIMENT_NAME,
} from '@/constants/global';

import { isIndexablePage } from '~/util/global';

const initialState = () => ({
  [CART_LOGIN_REDIRECT_EXPERIMENT_NAME]: 'disabled',
  [DESKTOP_STICKY_BUY_EXPERIMENT_NAME]: 'control',
  [PDP_SAVE_BADGE_EXPERIMENT_NAME]: 'control',
  [HIDE_STICKY_TABS_EXPERIMENT_NAME]: 'control',
  [PROJECT_FOMO_EXPERIMENT_NAME]: 'control',
});

// for accurate conversion rate tracking whitelist the pages your experiment is applicable
const EXPERIMENT_WHITELIST = {};

export { initialState as state };

export const getters = {
  getExperimentVariant: (state) => (experimentKey) => (
    state?.[experimentKey]
  ),
};

export const mutations = {
  set(state, data) {
    Object.keys(data).forEach((key) => {
      state[key] = data[key]; // eslint-disable-line no-param-reassign
    });
  },
};

export const actions = {
  async enroll({ commit }) {
    const isWhitelisted = (rules) => !!rules.find(
      (rule) => this.$router.currentRoute.fullPath.match(rule),
    );

    // experiments to enroll in
    const experimentKeys = [
      CART_LOGIN_REDIRECT_EXPERIMENT_NAME,
      DESKTOP_STICKY_BUY_EXPERIMENT_NAME,
      PDP_SAVE_BADGE_EXPERIMENT_NAME,
      HIDE_STICKY_TABS_EXPERIMENT_NAME,
      PROJECT_FOMO_EXPERIMENT_NAME,
    ];

    const promises = [];
    experimentKeys.forEach((experimentKey) => {
      // add all experiments to run if they are whitelisted or if there is no whitelist
      const whitelist = EXPERIMENT_WHITELIST[experimentKey];

      promises.push(whitelist && !isWhitelisted(whitelist)
        ? Promise.resolve(undefined) : this.$experiments.enroll(experimentKey));
    });

    const state = {};
    const results = await Promise.all(promises);
    // process results and set any that are not undefined
    results.forEach((result, index) => {
      const experimentKey = experimentKeys[index];

      if (result !== undefined) {
        state[experimentKey] = result;
      }
    });

    if (Object.keys(state).length > 0) {
      commit('set', state);
    }
  },

  // enrollNextNuxtExperiments will enroll in experiments based on the current path
  // This is specifically used for the Next/Nuxt experiments
  // which have experiments that are path specific and the variants are required to be set before
  // the page is even hit
  async enrollNextNuxtExperiments() {
    // This should only be run on the client
    if (typeof window === 'undefined') {
      return;
    }
    const path = window.location.pathname;
    const comparisonPath = path && path.endsWith && path.endsWith('/') ? path : `${path}/`; // NOSONAR - Failing build using optional chaining

    // We actually don't need the result of these experiments, we just need to enroll in them
    if (comparisonPath.startsWith('/products/')) {
      const experimentName = isIndexablePage(comparisonPath)
        ? USE_NEXT_QUESTION_REVIEW_EXPERIMENT_NAME
        : USE_NEXT_PDP_EXPERIMENT_NAME;

      this.$experiments.enroll(experimentName);
    }
  },

  async enrollByName({ commit }, name) {
    const experimentValue = await this.$experiments.enroll(name);

    commit('set', { [name]: experimentValue });
  },

  async getVariantsWithoutEnrolling({ commit }, names) {
    const experimentVariants = await this.$experiments.getVariantsWithoutEnrolling(names);

    // Loop through experimentVariants and set the state
    names.forEach((name) => {
      if (experimentVariants[name]) {
        commit('set', { [name]: experimentVariants[name] });
      }
    });
  },
};
